import Route from '@ember/routing/route';
import { service } from '@ember/service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import CacheService from 'donor-elf-web/services/cache-service';
import Store from '@ember-data/store';

export default class LogoutRoute extends Route {
  @service declare cacheService: CacheService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare session: any;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'Logging Out';
  }

  async model() {
    await this.cacheService.unloadAll();
    await this.store.createRecord('logout').save();

    if (this.session.isAuthenticated) {
      await this.session.invalidate();
    }
  }

  afterModel() {
    this.navbarSettings.title = 'Logged Out';
  }
}
